import styled from 'styled-components'

import { Colours } from '@lib/theme'

export interface Props {
  isError: boolean
  message?: string
}

export function InlineError({
  isError,
  message = 'Something went wrong, please try reloading this page',
}: Props) {
  if (!isError) {
    return null
  }

  return <P>{message}</P>
}

const P = styled.p`
  background-color: ${Colours.BgShade.Darker};
  padding: 0.5rem;
  border-radius: 0.25rem;

  font-weight: 700;
  color: ${Colours.Brand.RedMid};
`
